import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		formPopupAllPerilOptionsIneligibleNotification_container: {
			display: 'flex',
			flexDirection: 'column',
		},
		formPopupAllPerilOptionsIneligibleNotification_title: {
			color: theme.palette.info.main,
			margin: theme.spacing(2),
		},
		formPopupAllPerilOptionsIneligibleNotification_perilLabelItems: {
			margin: theme.spacing(1.5, 0),
			'& > li:last-child': {
				marginTop: theme.spacing(2),
				marginBottom: theme.spacing(0),
			},
			'& > li:first-child': {
				marginTop: theme.spacing(0),
				marginBottom: theme.spacing(2),
			},
			'& > li:nth-child(n+2):nth-last-child(n+2)': {
				margin: theme.spacing(2, 0),
			},
			'& > li:only-child': {
				margin: theme.spacing(0),
			}
		},
		formPopupAllPerilOptionsIneligibleNotification_perilLabelItem: {
			color: theme.palette.info.main,
		},
		formPopupAllPerilOptionsIneligibleNotification_messageIntro: {
			marginBottom: theme.spacing(1.5),
		}
	});
});

export default useStyles;
